import React, { useState, useEffect, useRef } from 'react'
import { useTheme } from 'styled-components'
import { useHistory } from 'react-router-dom'

import {
  Container,
  NoOrdersWrapper,
  MyOrdersMenuContainer,
  CalendarWrapper
} from './styles'
import { Calendar } from 'react-bootstrap-icons'
import { useConfig, useLanguage } from '~components'

import { Tab, Tabs, Button, OrdersOption, Modal, useWindowSize } from '~ui'
import { GiftCardOrdersList } from '../GiftCard/GiftCardOrdersList'
import { DateRange } from 'react-date-range'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { format } from 'date-fns'

export const MyOrders = (props) => {
  const {
    hideOrders,
    isFromBusinessListingSearch,
    businessesSearchList,
    onProductRedirect,
    onRedirectPage
  } = props

  const [, t] = useLanguage()
  const history = useHistory()
  const window = useWindowSize()
  const theme = useTheme()
  const [{ configs }] = useConfig()
  const layout = theme?.orders?.components?.layout?.type || 'original'

  const [isEmptyActive, setIsEmptyActive] = useState(false)
  const [isEmptyPast, setIsEmptyPast] = useState(false)
  const [isEmptyPreorder, setIsEmptyPreorder] = useState(false)
  const [selectedOption, setSelectedOption] = useState(!hideOrders ? 'orders' : 'business')
  const [isEmptyBusinesses, setIsEmptyBusinesses] = useState(false)
  const [businessOrderIds, setBusinessOrderIds] = useState([])

  const hidePreviousOrders = theme?.orders?.components?.past_orders?.hidden
  const hideProductsTab = theme?.orders?.components?.products_tab?.hidden
  const hideBusinessTab = theme?.orders?.components?.business_tab?.hidden
  const isWalletEnabled = configs?.cash_wallet?.value && configs?.wallet_enabled?.value === '1' && (configs?.wallet_cash_enabled?.value === '1' || configs?.wallet_credit_point_enabled?.value === '1')

  const MyOrdersMenu = [
    { key: 'orders', value: t('ORDERS', 'Orders'), disabled: false },
    { key: 'business', value: t('BUSINESS', 'Business'), disabled: hideBusinessTab },
    { key: 'products', value: t('PRODUCTS', 'Products'), disabled: hideProductsTab },
    { key: 'giftCards', value: t('GIFT_CARD', 'Gift card'), disabled: !isWalletEnabled }
  ]

  const notOrderOptions = ['business', 'products', 'professionals']
  const allEmpty = (isEmptyActive && isEmptyPast && isEmptyPreorder) || ((isEmptyBusinesses || businessOrderIds?.length === 0) && hideOrders)

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ])
  const [selected, setSelected] = useState(false)
  const [dateVersion, setDateVersion] = useState(0)
  const [dateResetVal, setDateResetVal] = useState(0)
  const [open, setOpen] = useState(false)
  const refOne = useRef(null)

  const handleResetCalender = () => {
    setDateRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ])
    setSelected(false)
    setDateVersion(0)
    setDateResetVal(0)
    setOpen(false)
  }

  useEffect(() => {
    document.addEventListener('keydown', hideOnEscape, true)
    document.addEventListener('click', hideOnClickOutside, true)
  }, [])

  const hideOnEscape = (e) => {
    if (e.key === 'Escape') {
      setOpen(false)
    }
  }

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false)
    }
  }

  return (
    <>
      {hideOrders && !allEmpty && (
        <h2>{t('PREVIOUSLY_ORDERED', 'Previously ordered')}</h2>
      )}
      <Container hideOrders={hideOrders} initialHeight={isFromBusinessListingSearch}>
        {!hideOrders && (
          <h1>{layout === 'appointments' ? t('MY_APPOINTMENTS', 'My appointments') : t('MY_ORDERS', 'My orders')}</h1>
        )}
        {(!allEmpty || dateVersion !== 0 || dateResetVal === 0) && (
          <MyOrdersMenuContainer className='category-lists'>
            <Tabs variant='primary'>
              {MyOrdersMenu.filter(option => (!hideOrders || option.key !== 'orders') && !option.disabled).map(option => (
                <Tab
                  key={option.key}
                  onClick={() => setSelectedOption(option.key)}
                  active={selectedOption === option.key}
                  borderBottom
                >
                  {option?.value}
                </Tab>
              ))}
              {layout === 'appointments' && (
                <Tab
                  onClick={() => setSelectedOption('professionals')}
                  active={selectedOption === 'professionals'}
                  borderBottom
                >
                  {t('PROFESSIONALS', 'Professionals')}
                </Tab>
              )}
            </Tabs>
            {selectedOption === 'orders' && window.width >= 600 && (
              <div
                style={{
                  position: 'absolute', right: 0, display: 'flex', alignItems: 'center', padding: 10, backgroundColor: '#eee', borderRadius: 7
                }}
              >
                <Calendar size={20} color="#555" />
                <input
                  value={
                    selected
                      ? `${format(dateRange[0].startDate, 'yyyy-MM-dd')} - ${format(
                        dateRange[0].endDate,
                        'yyyy-MM-dd'
                      )}`
                      : 'Select date range'
                  }
                  readOnly
                  className="inputBox"
                  onClick={() => setOpen(!open)}
                  style={{
                    border: 'none',
                    outline: 'none',
                    backgroundColor: '#eee',
                    marginLeft: 10,
                    minWidth: '150px',
                    flexGrow: 1
                  }}
                />
              </div>
            )}

          </MyOrdersMenuContainer>

        )}
        {selectedOption === 'orders' && window.width < 600 && (
          <div
            style={{

              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              padding: 10,
              backgroundColor: '#eee',
              borderRadius: 7,
              maxWidth: '100%'
            }}
          >
            <Calendar size={20} color="#555" />
            <input
              value={
                selected
                  ? `${format(dateRange[0].startDate, 'yyyy-MM-dd')} - ${format(
                    dateRange[0].endDate,
                    'yyyy-MM-dd'
                  )}`
                  : 'Select date range'
              }
              readOnly
              className="inputBox"
              onClick={() => setOpen(!open)}
              style={{
                border: 'none',
                outline: 'none',
                backgroundColor: '#eee',
                marginLeft: 10,
                minWidth: '150px',
                flexGrow: 1
              }}
            />
          </div>
        )}

          {open && (
          <Modal
            open={open}
            onClose={() => setOpen(false)}
            >
            <CalendarWrapper
              ref={refOne}
              notSelected={!dateRange[0].startDate}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
            >
              <DateRange
                onChange={(item) => {
                  const { startDate, endDate } = item.selection
                  setDateRange([{ ...item.selection }])
                  setSelected(true)
                  setDateResetVal(1)
                  setDateVersion(prev => prev + 1)
                  if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
                    setTimeout(() => setOpen(false), 800)
                  }
                }}
                editableDateInputs
                moveRangeOnFirstSelection={false}
                ranges={dateRange}
              />

              {/* ✅ Reset button is now inside refOne */}
              <button
                onClick={handleResetCalender}
                style={{
                  marginTop: 10,
                  padding: '6px 14px',
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  backgroundColor: '#f5f5f5',
                  cursor: 'pointer'
                }}
              >
                Reset
              </button>
            </CalendarWrapper>
            </Modal>
          )}

        { selectedOption === 'orders' && dateVersion !== 0 && dateResetVal === 1 && (
          <>
          <OrdersOption
              {...props}
              preOrders
              horizontal
              setIsEmptyPreorder={setIsEmptyPreorder}
              dateRange={dateRange}
              isShowProduct={selected}
            />
            <OrdersOption
              {...props}
              activeOrders
              horizontal
              setIsEmptyActive={setIsEmptyActive}
              dateRange={dateRange}
              isShowProduct={selected}
            />
            <OrdersOption
              {...props}
              pastOrders
              setIsEmptyPast={setIsEmptyPast}
              dateRange={dateRange}
              isShowProduct={selected}
              handleRedirectToCheckout={uuid => {
                onRedirectPage && onRedirectPage({ page: 'checkout', params: { cartUuid: uuid } })
              }}
            />
          </>
        )}
        {selectedOption === 'orders' && dateVersion === 0 && dateResetVal === 0 && (
          <>
            {(isEmptyActive && isEmptyPast && isEmptyPreorder && dateResetVal !== 0)
              ? (
              <NoOrdersWrapper>
                <p>{t('YOU_DONT_HAVE_ORDERS', 'You don\'t have any orders')}</p>
                <Button
                  color='primary'
                  onClick={() => history.push('/')}
                >
                  {t('ORDER_NOW', 'Order now')}
                </Button>
              </NoOrdersWrapper>
                )
              : (
              <>
                <OrdersOption
                  {...props}
                  preOrders
                  horizontal
                  setIsEmptyPreorder={setIsEmptyPreorder}
                  dateRange={dateRange}
                />
                <OrdersOption
                  {...props}
                  activeOrders
                  horizontal
                  setIsEmptyActive={setIsEmptyActive}
                  dateRange={dateRange}
                />
                <OrdersOption
                  {...props}
                  pastOrders
                  setIsEmptyPast={setIsEmptyPast}
                  dateRange={dateRange}
                  handleRedirectToCheckout={uuid => {
                    onRedirectPage && onRedirectPage({ page: 'checkout', params: { cartUuid: uuid } })
                  }}
                />
              </>
                )}
          </>
        )}
        {notOrderOptions.includes(selectedOption) && !hidePreviousOrders
          ? (<OrdersOption
              {...props}
              titleContent={t('PREVIOUSLY_ORDERED', 'Previously ordered')}
              hideOrders
              horizontal
              isBusiness={selectedOption === 'business'}
              isProducts={selectedOption === 'products'}
              isProfessionals={selectedOption === 'professionals'}
              activeOrders
              pastOrders
              preOrders
              businessesSearchList={businessesSearchList}
              setIsEmptyBusinesses={setIsEmptyBusinesses}
              businessOrderIds={businessOrderIds}
              setBusinessOrderIds={setBusinessOrderIds}
              onProductRedirect={onProductRedirect}
            />)
          : selectedOption !== 'giftCards'
            ? <NoOrdersWrapper>
                <p>{t('NOTHING_TO_SHOW', 'Nothing to show')}</p>
              </NoOrdersWrapper>
            : null}
        {selectedOption === 'giftCards' && (
          <GiftCardOrdersList />
        )}
      </Container>
    </>
  )
}
